module.exports = __webpack_public_path__ + "img/logo-bootstrap.c6707de1.svg";